import React from 'react';
import { Link } from '@tanstack/react-router';

import MemoryAssets from '../MemoryCard/Assets';
import TimelineCardStats from '../TimelineCard/Stats';

import { formatDate } from '../../helpers';
import { setShareModalTimeline } from '../../helpers/timeline';

import type { Asset } from '../../types/asset';
import type { Timeline } from '../../types/timeline';

const TimelineCard: React.FC<{ timeline: Timeline }> = ({ timeline }) => {
  const assets = timeline.memories.map(memory => memory.assets).flat() as Asset[];

  return (
    <wa-card className="memory-card timeline-card dashboard-timeline-card">
      <div className="dashboard-timeline-card-content wa-stack wa-gap-2xs">
        <MemoryAssets files={assets} variant="timeline" />
        <h5 className="dashboard-timeline-card-title">
          {timeline.dedicated_to}
        </h5>
        <div className="memory-card-meta timeline-card-meta dashboard-timeline-card-date">
          {formatDate(timeline.created_at)}
        </div>
        <hr />
        <TimelineCardStats timeline={timeline} />
        <div className="wa-cluster dashboard-card-buttons dashboard-timeline-card-buttons" style={{ '--min-column-size': '1em' } as React.CSSProperties}>
          <Link to="#" data-dialog="open share-modal" onClick={(e) => { e.preventDefault(); setShareModalTimeline(timeline.id); }}>
            <i className="fa-light fa-arrow-up-from-bracket" slot="start" />
            Share
          </Link>
          <Link to={`/timelines/${timeline.id}/edit`}>
            <i className="fa-light fa-pencil" slot="start" />
            {timeline.capabilities.can_update ? 'Edit' : 'Contribute'}
          </Link>
          <Link to={`/t/${timeline.id}`}>
            <i className="fa-light fa-eye" slot="start" />
            View
          </Link>
          <Link to={`/dashboard/timelines/${timeline.id}`}>
            <i className="fa-light fa-chart-simple" slot="start" />
            Stats
          </Link>
        </div>
      </div>
    </wa-card>
  );
}

export default TimelineCard;
